import { useCallback } from "react";
import { RouteAgreementFormModel } from "../types/RouteAgreementFormModel";
import { conditionsFormRedux } from "../redux/ConditionsFormRedux";
import { routesFormRedux } from "../redux/RoutesFormRedux";
import { notesFormRedux } from "../redux/NotesFormRedux";
import { articleFormActions } from "../redux/articles-actions";
import { batch, useDispatch, useSelector } from "react-redux";
import { Dispatch } from "redux";
import { matrixFormRedux } from "../redux/MatrixFormRedux";
import { rateSheetTableActions } from "../../product-and-price/rate-sheet/actions";
import { rateSheetTableSelectors } from "../../product-and-price/rate-sheet/selectors";
import { RateSheetTableState } from "../../product-and-price/rate-sheet/reducer";
import {
  createRecordObjectActions,
  RecordObjectState,
  reducerIdGateAction,
} from "@stenajs-webui/redux";

export const useResetForms = (originalFormModel: RouteAgreementFormModel) => {
  const dispatch = useDispatch();
  const table = useSelector(rateSheetTableSelectors.getTableState);

  const resetForms = useCallback(
    () =>
      batch(() =>
        dispatchResetRouteAgreementForms(originalFormModel, dispatch, table)
      ),
    [dispatch, originalFormModel, table]
  );

  return {
    resetForms,
  };
};

export const dispatchResetRouteAgreementForms = (
  originalFormModel: RouteAgreementFormModel,
  dispatch: Dispatch,
  table: RecordObjectState<RateSheetTableState>
) => {
  dispatch(conditionsFormRedux.actions.setEntity(originalFormModel.conditions));
  dispatch(routesFormRedux.actions.setEntity(originalFormModel.routes));
  dispatch(notesFormRedux.actions.setEntity(originalFormModel.notes));
  dispatch(articleFormActions.setFormModel(originalFormModel.articles));
  dispatch(matrixFormRedux.actions.setEntity(originalFormModel.matrix));
  const routeAgreementIds = Object.keys(table);
  routeAgreementIds.forEach((routeAgreementId) => {
    dispatch(
      reducerIdGateAction(
        "rateSheetTableRows",
        createRecordObjectActions().recordAction(
          routeAgreementId,
          rateSheetTableActions.revertAllModifications()
        )
      )
    );
  });
};
